import { Button, Flex, toast } from '@approvalmax/ui/src/components';
import { FC, memo, useCallback } from 'react';
import { useCompanyBetaFeatures, useCompanyIdBasedOnUrl } from 'shared/hooks';

import { useOffboardingContext } from '../../OffboardingContext';
import { validateExternalRequester } from '../../OffboardUserPopupContent.helpers';
import { messages } from './PopupButtonsStep2.messages';
import { PopupButtonsStep2Props } from './PopupButtonsStep2.types';

const PopupButtonsStep2: FC<PopupButtonsStep2Props> = memo((props) => {
    const { isLoading, offboardUserData, offboardUserMutate, back } = props;

    const { setShowErrors, selectedReplacements: selectedDelegates, showErrors } = useOffboardingContext();

    const { companyId } = useCompanyIdBasedOnUrl();
    const { isPayerOffboarding } = useCompanyBetaFeatures(companyId);

    const onSubmit = useCallback(() => {
        const formValid =
            offboardUserData && validateExternalRequester(offboardUserData, selectedDelegates, isPayerOffboarding);

        if (!formValid) {
            setShowErrors(true);
            toast.error(messages.error);
        } else {
            setShowErrors(false);
            offboardUserMutate();
        }
    }, [offboardUserMutate, offboardUserData, selectedDelegates, setShowErrors, isPayerOffboarding]);

    return (
        <Flex spacing='8' wrap={false}>
            <Button color='blue10' size='medium' disabled={isLoading} onClick={back}>
                {messages.backButtonText}
            </Button>

            <Button
                color='blue80'
                size='medium'
                progress={isLoading}
                disabled={
                    !isLoading &&
                    (!offboardUserData ||
                        (!validateExternalRequester(offboardUserData, selectedDelegates, isPayerOffboarding) &&
                            showErrors))
                }
                onClick={onSubmit}
            >
                {messages.offBoardButtonText}
            </Button>
        </Flex>
    );
});

export default PopupButtonsStep2;
